export const esCreditoRecordatorio = (row, today = new Date()) => {
  const year = Number(String(row?.cuotaPrestamo?.fecha ?? row?.fecha ?? '').slice(0, 4))
  const currentYear = Number(new Intl.DateTimeFormat('en', {
    timeZone: 'America/Santiago', year: 'numeric'
  }).format(today))
  return Number(row?.folioCredito) === 6 && Math.abs(Number(row?.comprobante)) === 4 &&
    year > 0 && year < currentYear
}
